import { Requests } from '@trello/quickload';
import type { QuickloadResponse } from '@trello/quickload';

import { client, syncDeltaToCache, DataWithId } from '@trello/graphql';

export const hydrateApolloCacheFromQuickloadResults = (
  results: QuickloadResponse[],
): void => {
  const path = window.location.pathname;
  const preloadKeyMatch = Object.keys(Requests).find((routeRegExp) =>
    new RegExp(routeRegExp).test(path),
  );
  const preloads = preloadKeyMatch && Requests[preloadKeyMatch];

  if (results.length === 0 || !results[0]) {
    return;
  }

  const allPreloads = Requests.header.concat(preloads || []);

  for (let i = 0; i < allPreloads.length; i++) {
    const { query, modelName } = allPreloads[i];
    const data = results[i]?.[0];

    if (!data) {
      continue;
    }

    syncDeltaToCache(client, modelName, (data as unknown) as DataWithId, {
      fromDocument: query,
    });
  }
};
